import { Action } from '@ngrx/store';
import { MenuItem } from '../models/menu-items';
import { RequestWrap } from '../../core/models/request-wrap';

export const INIT = '[Menus] Init'
export const GET = '[Menus] Get Menus'
export const GET_SKIPPED = '[Menus] Get skipped'
export const GET_SUCCESS = '[Menus] Get Menus Success'
export const GET_FAILED = '[Menus] Get Menus Failed'

export const NAVIGATE = '[Menus] Navigate'

export const TOGGLE_MEGA_MENU = '[Menus] Toggle Mega Menu'

export class Init implements Action {
  readonly type = INIT
  constructor(public forceRefresh: boolean = false) {}
}
export class GetSkipped implements Action {
  readonly type = GET_SKIPPED
}
export class Get implements Action {
  readonly type = GET
}
export class GetSuccess implements Action {
  readonly type = GET_SUCCESS
  constructor(public payload: RequestWrap<MenuItem[]>) {}
}
export class GetFailed implements Action {
  readonly type = GET_FAILED
  constructor(public payload: string | null) {}
}
export class Navigate implements Action {
  readonly type = NAVIGATE
  constructor(public payload: string) {}
}

export class ToggleMegaMenu implements Action {
  readonly type = TOGGLE_MEGA_MENU
  constructor(public payload: boolean) {}
}

export type Actions =
  Init
  | GetSkipped
  | Get
  | GetSuccess
  | GetFailed
  | Navigate
  | ToggleMegaMenu
